/* TRNK& headline fit: a long word never splits in the middle. If the widest word doesn't fit, the title shrinks until it does. */
(function () {
    var SELECTOR = '.trnk-lead-title, .gh-article-title, .trnk-empty-title';
    var MIN_RATIO = 0.45; // never below 45 % of the designed size
    var MIN_PX = 20;

    function contentWidth(el, style) {
        return el.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
    }

    function widestWord(el, words) {
        // The probe sits inside the title, so it inherits the uppercase, the width axis and the letter spacing.
        var probe = document.createElement('span');
        probe.setAttribute('aria-hidden', 'true');
        probe.style.cssText = 'position:absolute;top:0;left:-9999px;visibility:hidden;white-space:nowrap;';
        el.appendChild(probe);
        var widest = 0;
        words.forEach(function (word) {
            probe.textContent = word;
            widest = Math.max(widest, probe.getBoundingClientRect().width);
        });
        el.removeChild(probe);
        return widest;
    }

    function fit(el) {
        el.style.fontSize = '';
        el.classList.remove('trnk-fit-break');
        var words = (el.textContent || '').trim().split(/\s+/).filter(Boolean);
        if (!words.length) return;
        var style = window.getComputedStyle(el);
        var width = contentWidth(el, style);
        if (width <= 0) return;
        var widest = widestWord(el, words);
        if (widest <= width) return;
        var size = parseFloat(style.fontSize);
        var wanted = size * (width / widest) * 0.97;
        var floor = Math.max(size * MIN_RATIO, MIN_PX);
        el.style.fontSize = Math.max(wanted, floor).toFixed(1) + 'px';
        // A single absurdly long word (a URL, say) may break as a last resort.
        if (wanted < floor) el.classList.add('trnk-fit-break');
    }

    function run() {
        Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), fit);
    }

    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    window.addEventListener('load', run);

    var lastWidth = window.innerWidth;
    var timer;
    window.addEventListener('resize', function () {
        if (window.innerWidth === lastWidth) return; // mobile toolbars change only the height
        lastWidth = window.innerWidth;
        clearTimeout(timer);
        timer = setTimeout(run, 120);
    });
}());
